export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            关于我们
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-xl border border-background-200/60 p-8 md:p-10">
            <div className="flex flex-col md:flex-row gap-8 items-center">
              <div className="w-20 h-20 md:w-24 md:h-24 flex-shrink-0 flex items-center justify-center rounded-2xl bg-primary-500">
                <i className="ri-movie-2-line text-3xl md:text-4xl text-white"></i>
              </div>
              <div className="flex-1 text-center md:text-left">
                <h3 className="text-xl font-bold font-heading text-foreground-950">
                  日韩影视网
                </h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                  日韩影视网成立于2020年，是国内领先的日韩电视剧在线观看平台。我们致力于为华语用户提供最全、最新、最高清的日剧全集与韩剧全集资源。平台汇聚超过5000部日韩电视剧，涵盖爱情、悬疑、喜剧、古装、医疗、职场等全品类内容，每日同步更新最新剧集。我们采用全球CDN加速分发技术，确保您无论身在何处，都能享受高清不缓冲的流畅追剧体验。日韩影视网，让每一部好剧都不被错过。
                </p>
                <div className="mt-5 flex flex-wrap items-center gap-6 justify-center md:justify-start text-sm">
                  <div className="flex items-center gap-2 text-foreground-700">
                    <i className="ri-check-double-line text-accent-500"></i>
                    <span>5000+ 部剧集</span>
                  </div>
                  <div className="flex items-center gap-2 text-foreground-700">
                    <i className="ri-check-double-line text-accent-500"></i>
                    <span>每日同步更新</span>
                  </div>
                  <div className="flex items-center gap-2 text-foreground-700">
                    <i className="ri-check-double-line text-accent-500"></i>
                    <span>1080P 高清画质</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}